import React from 'react';
import { Typography, Button, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Error as ErrorIcon } from '@mui/icons-material';
import brandingConfig from '../../config/brandingConfig';

const ErrorContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '200px',
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
  borderRadius: theme.shape.borderRadius,
}));

const ErrorIconStyled = styled(ErrorIcon)(({ theme }) => ({
  fontSize: 60,
  color: theme.palette.error.main,
  marginBottom: theme.spacing(2),
}));

const ErrorTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
}));

const ErrorMessage = ({ 
  title = 'Ein Fehler ist aufgetreten', 
  message = 'Beim Laden der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.', 
  onRetry = null 
}) => {
  return (
    <ErrorContainer elevation={3}>
      <ErrorIconStyled />
      <ErrorTitle variant="h5">
        {title}
      </ErrorTitle>
      <Typography variant="body1" align="center" gutterBottom>
        {message}
      </Typography>
      {onRetry && (
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onRetry}
          sx={{ 
            mt: 2,
            backgroundColor: brandingConfig.colors.primary,
            '&:hover': {
              backgroundColor: brandingConfig.colors.primary,
              filter: 'brightness(90%)'
            }
          }}
        >
          Erneut versuchen
        </Button>
      )}
    </ErrorContainer>
  );
};

export default ErrorMessage;